export default __webpack_public_path__ + "static/bubble-2da2e06c29545f96bafa76e0774e2a03.png";